import React from 'react';
import { Link } from 'react-router-dom';

import Gravatar from 'react-gravatar';

class TeachersListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleToggleRecipient = this.handleToggleRecipient.bind(this);
  }

  handleToggleRecipient() {
    this.props.onToggleRecipient();
  }

  handleClick(teacher) {
    this.props.onClick(teacher);
  }

  render() {
    var teacher = this.props.teacher;
    const rowStyle = {
      cursor: 'pointer',
      transition: 'all 0.1s ease-in-out'
    };

    return (
      <tr className="py-3" style={{borderBottom: '1px solid #ddd'}}>
        {
          this.props.onToggleRecipient ? (
            <td>
              <input type="checkbox" checked={this.props.hasRecipient} onClick={this.handleToggleRecipient} className="mr-2" />
            </td>
          ) : ''
        }
        <td width="50" valign="middle" className="pr-1">
          <Gravatar email={teacher.email} size={60} className="float-left mr-2" />
        </td>
        <td width="35%" className="py-2">
          <Link to={'/teachers/' + teacher.teacher_key + '/view/'}>
            {
              teacher.subject && (
                <div>
                  <span className="mb-1" style={{color: '#999', fontSize: '14px'}}>
                    <i className="fa fa-chalkboard-teacher mr-1" style={{fontSize: '13px'}} />
                    INS. {teacher.subject ? teacher.subject.toUpperCase() : 'N/D'}
                  </span>
                </div>
              )
            }
            <strong style={{whiteSpace: 'nowrap'}}>
              {teacher.first_name} {teacher.last_name}
            </strong>
          </Link>
          <br /><small><a href={'mailto:' + teacher.email}>{teacher.email}</a></small>
        </td>
        <td width="32%" className="py-2">
          {
            teacher.schools_data && teacher.schools_data.map((school) => {
              return (
                <div>
                  {
                    school.name ? (
                      <div>
                        <p className="mb-1" style={{color: '#999', fontSize: '14px'}}>
                          <i className={'fa ' + (school.parent_school_id ? 'fa-school' : 'fa-university') + ' mr-1'}  style={{fontSize: '13px'}} /> {school.type}
                        </p>
                        <strong>{school.name}</strong><br />
                        {school.city_name} ({school.province_iso_code})<br />
                        <span style={{fontSize: '12px', color: '#999'}}>C.M.: {school.id}</span>
                      </div>
                    ) : ''
                  }
                </div>
              );
            })
          }
        </td>
        <td width="7%" className="py-2" align="center">
          {
            teacher.order_ids !== undefined && (
              <div>
                <i className="fa fa-shopping-cart" /> {teacher.order_ids ? teacher.order_ids.length : 0}
              </div>
            )
          }
        </td>
        <td width="8%" className="py-2" align="center">
          {
            teacher.num_students !== undefined && (
              <div>
                <i className="fa fa-user" /> {teacher.num_students}
              </div>
            )
          }
        </td>
        <td width="5%" className="py-2" align="center">
          {
            teacher.school_ids !== undefined && (
              <div>
                <i className="fa fa-school" /> {teacher.school_ids ? teacher.school_ids.length : 0}
              </div>
            )
          }
        </td>
        <td width="13%" className="py-2" align="right">
          <Link to={'/teachers/' + teacher.teacher_key + '/view'}>
            <i className="fa fa-arrow-right" /> Vai ai dettagli
          </Link>
        </td>
      </tr>
    );
  }
}

export default TeachersListItem;


// WEBPACK FOOTER //
// ./src/components/teachers/TeacherListItem.js